export const CartConflictMessageDataHooks = {
  NOTIFICATION_MESSAGE: 'cart-condlict-notification-message',
};
